import { WidgetViewModel } from '../../viewModel/viewModel';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export type OnDialogCloseAction = () => void;

export const createOnDialogCloseAction = ({
  widgetViewModel,
  setProps,
  flowAPI,
}: {
  widgetViewModel: WidgetViewModel;
  setProps: Function;
  flowAPI: ControllerFlowAPI;
}): OnDialogCloseAction => {
  return () => {
    if (flowAPI.experiments.enabled('specs.bookings.GenericDialogComponent')) {
      widgetViewModel.dialogViewModel.isOpen = false;
    } else {
      widgetViewModel.showDialog = false;
    }
    setProps({
      widgetViewModel: { ...widgetViewModel },
    });
  };
};
